import React, { FC } from 'react'

interface LoadingProps {
  size?: string
  padding?: string
  border?: string
}

const Loading: FC<LoadingProps> = (props) => {
  const {
    size,
    padding,
    border,
  } = props

  const sizeVal = size === undefined ? "35px" : size
  const paddingVal = padding === undefined ? "50px" : padding
  const borderVal = border === undefined ? ".25em" : border
  const style = {
    root: {
      display: 'flex',
      justifyContent: 'center',
      padding: paddingVal,
    },
    spinner: {
      display: 'inline-block',
      width: sizeVal,
      height: sizeVal,
      border: `${borderVal} solid #4a7ecd`,
      borderRightColor: 'transparent',
      borderRadius: '50%',
      animation: 'rotation-frame .75s linear infinite',
    },
  }
  return (
    <div style={style.root} className="loading_block">
      <div style={style.spinner} />
    </div>
  )
}

Loading.defaultProps = {
  size: undefined,
  padding: undefined,
  border: undefined,
}

export default Loading
